import { Navigate, useLocation } from "@/lib/router-compat";

// Mapa de URLs antigas (WordPress) e posts removidos -> destino atual.
// O servidor (public/.htaccess) faz 301; aqui garantimos o mesmo comportamento na SPA.
export const LEGACY_REDIRECTS: Record<string, string> = {
  "/resolvendo-problemas-reais-como-agentes-de-ia-solucionam-gargalos-de-negocios":
    "/blog/como-ia-esta-revolucionando-atendimento-cliente",
  "/o-futuro-do-trabalho-como-a-ia-libera-o-potencial-humano-nas-empresas":
    "/blog/futuro-da-comunicacao-empresarial-ia",
  "/ia-e-omnichannel-construindo-experiencias-de-cliente-sem-emendas":
    "/blog/crm-integrado-whatsapp-vantagens",
  "/o-poder-da-omniconexao-como-integrar-seus-processos-para-o-sucesso-empresarial":
    "/blog/crm-integrado-whatsapp-vantagens",
  "/ia-para-industrias-e-grandes-empresas-otimizando-a-producao-e-a-gestao":
    "/blog/ia-generativa-transformando-negocios",
  "/desvendando-os-gargalos-como-a-ia-identifica-e-elimina-ineficiencias-operacionais":
    "/blog/ia-generativa-transformando-negocios",
  "/blog/ia-generativa-transformando-negocios-brasileiros":
    "/blog/ia-generativa-transformando-negocios",
  "/blog/chatbot-whatsapp-como-funciona": "/blog/guia-completo-automacao-whatsapp-2026",
  "/blog/lgpd-chatbot-whatsapp": "/blog/5-erros-fatais-atendimento-whatsapp",
  "/blog/clone-de-voz-ia-marketing": "/blog/futuro-da-comunicacao-empresarial-ia",
  "/blog/como-automatizar-atendimento-whatsapp": "/blog/automacao-vendas-whatsapp-passo-a-passo",
  "/blog/ia-para-whatsapp-melhores-ferramentas-2026": "/blog/guia-completo-automacao-whatsapp-2026",
};

/** Retorna o destino se a rota atual for legada; caso contrario, null. */
export function resolveLegacyPath(pathname: string): string | null {
  const clean = pathname.replace(/\/+$/, "") || "/";
  return LEGACY_REDIRECTS[clean] ?? null;
}

export function LegacyRedirectGate({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const target = resolveLegacyPath(pathname);
  if (target) return <Navigate to={target} replace />;
  return <>{children}</>;
}
